
import { createSelector } from "@reduxjs/toolkit";
export const changePassword = state => state.settingAccountReducer.changePassword;
export const whatYouNeed = state => state.settingAccountReducer.whatYouNeed;
export const inviteCode = state => state.settingAccountReducer.inviteCode;
export const unlink = state => state.settingAccountReducer.unlink;
export const messageUnlink = state => state.settingAccountReducer.messageUnlink;
export const messageInviteError = state => state.settingAccountReducer.messageInviteError;

